import { z } from "zod";
import apiRepresentation3dSchema from "./apiRepresentation3dSchema";
import apiPlacementSchema from "../placementSchema";

const apiFbxAssetSchema = apiRepresentation3dSchema.extend({
    path: z.string(),
    placement: apiPlacementSchema,
    scaleToFit: z.boolean(),
    isMirrored: z.boolean()
  });

export default apiFbxAssetSchema;